import { Button, Col, Grid, notification, Row, Typography } from "antd"
import { ContactModal } from "../ContactModal/web"
import { FinancingInput } from "../FinancingInput/FinancingInput"
import { ImagenOptimizada } from "../../Image/web"
import { InputWithPercentage, Select } from "../dataInputs"
import { useItauFinancing } from "./hook"
import { useContext, useState } from "react"
import { useTheme } from "../../../Styles/ThemeHook"
import "./styles.less"
import { firstLetterToUppercase } from "src/utils/Functions"
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context"

const { useBreakpoint } = Grid;

const DESKTOP_SOURCE = 0;
const MOBILE_SOURCE = 4;

const LEAD_SERVICE = "https://prod.infocasas.com.uy/microservices/simulador/?/itau/sendForm";

export const ItauFinancing = ({
	id,
	isDisabledProperty = false,
	showFinancingCard = false,
	financingRef = null,
}) => {
	const handleClickShowNotification = async ({
		type = 'success',
		message = '',
		description = '',
	}) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(
			type,
			message,
			description
		);
	}
	const screen = useBreakpoint();
	const source = screen.lg ? DESKTOP_SOURCE : MOBILE_SOURCE;
	const {
		loan: { amount: loan, change: setLoan },
		property: { amount: propertyPrice },
		years: { value: years, change: setYears, totalYears },
		type: { value: type, change: setType, options: types },
		asset: { value: asset, change: setAsset, options: assets },
		setIsDefaultSimulation,
		payment,
		propertyCurrency,
		extraData,
		show,
		itauService,
	} = useItauFinancing({ id, source });
	const { theme } = useTheme();
	const [modal, setModal] = useState(false);
	const { translations } = useContext(ConfigStateContext);

	const onScrollToFinancing = () => {
		if (financingRef) {
			const componentFinancing = financingRef.current.offsetTop;
			const withAffixHeight = screen.lg ? 30 : 0;
			const scrollingTo = componentFinancing - withAffixHeight;
			window.scrollTo({ top: scrollingTo, behavior: "smooth" });
		}
	};

	const handleLoanChange = (value, type) => {
		if (type === "plus") setLoan(value + 1);
		else if (type === "minus") setLoan(value - 1);
		else setLoan(value)
	}

	if (!show) return null;

	if (showFinancingCard) {
		return (
			<div className="property-financing-itau-card">
				<div className="itau-header">
					{firstLetterToUppercase(translations.compra)} esta propiedad con la mejor financiación del mercado.
				</div>
				<div className="itau-footer">
					<div className="itau-logo">
						<ImagenOptimizada
							src="https://cdn4.fincaraiz.com.co/web/62f5221c4dd86_logo-itau.svg"
							alt="Itau"
						/>
						<span>{"Creando Oportunidades"}</span>
					</div>
					<Button onClick={onScrollToFinancing} className="itau-btn">
						{"Ver más"}
					</Button>
				</div>
			</div>
		);
	}

	return (
		<div className="property-financing-itau">
			<Row gutter={[0, theme.spacing.mdSpacing]}>
				<Col span={24}>
					<Typography.Title level={4}>{"Financiación"}</Typography.Title>
				</Col>
				<Col xs={24} md={16}>
					<div className="property-financing-box">
						<div className="itau-logo">
							<ImagenOptimizada
								src="https://cdn4.fincaraiz.com.co/web/62f5221c4dd86_logo-itau.svg"
								alt="ITAÚ"
							/>
							<span>{"Creando Oportunidades"}</span>
						</div>
						<Row gutter={[theme.spacing.xxlSpacing, theme.spacing.mdSpacing]}>
							<Col xs={24} md={12}>
								<FinancingInput
									title="Importe a Solicitar"
									input={
										<InputWithPercentage
											isDisabledProperty={isDisabledProperty}
											value={loan}
											max={propertyPrice}
											onChange={(value, type) => {
												handleLoanChange(value, type)
												setIsDefaultSimulation(false)
											}}
											percentage={Math.round((loan * 100) / propertyPrice)}
											currency={propertyCurrency}
										/>
									}
									fullWidth
								/>
							</Col>
							<Col xs={24} md={12}>
								<FinancingInput
									title="Plazo"
									input={
										<Select
											isDisabledProperty={isDisabledProperty}
											value={years}
											options={totalYears}
											onChange={(value) => {
												setYears(value)
												setIsDefaultSimulation(false)
											}}
										/>
									}
									fullWidth
								/>
							</Col>
							<Col xs={24} md={12}>
								<FinancingInput
									title="Tipo de Préstamo"
									input={
										<Select
											isDisabledProperty={isDisabledProperty}
											value={type}
											options={types}
											onChange={(value) => {
												setType(value)
												setIsDefaultSimulation(false)
											}}
										/>
									}
									fullWidth
								/>
							</Col>
							<Col xs={24} md={12}>
								<FinancingInput
									title="Financiación"
									input={
										<Select
											isDisabledProperty={isDisabledProperty}
											value={asset}
											options={assets}
											onChange={(value) => {
												setAsset(value)
												setIsDefaultSimulation(false)
											}}
										/>
									}
									fullWidth
								/>
							</Col>
						</Row>
					</div>
				</Col>
				<Col xs={24} md={8} className="property-financing-monthly-itau">
					{payment ? (
						<>
							<Typography.Title>{"Tu cuota mensual:"}</Typography.Title>
							<Typography.Title className="financing-price">
								Gs. {payment}
							</Typography.Title>
							<Button
								disabled={isDisabledProperty}
								className="itau-financing-button"
								onClick={() => setModal(true)}>
								{"Obtener más información"}
							</Button>
						</>
					) : null}
				</Col>
			</Row>
			<ContactModal
				sendLeadURL={LEAD_SERVICE}
				extraData={extraData}
				source={source}
				beforeSubmitForm={async () => {
					return await itauService();
				}}
				onSuccess={() => {
					setModal(false);
					handleClickShowNotification({
						message: "¡Gracias por tu consulta!",
						description: "Tus datos han sido enviados con éxito. En las próximas horas nos contactaremos contigo para darte más información.",
					});
				}}
				title="Calcular cuota de préstamo"
				topText="Completa estos datos para recibir más información"
				visible={modal}
				closeModal={() => setModal(false)}
				showCI={true}
			/>
		</div>
	);
};
